import React from 'react';
import { Form } from 'react-bootstrap';

import { pageCurrent, pageLimitDisabled, pageLimitEnabled } from '../../utils/pagination.util';
import { suffixLegend } from '../../scripts/name.legend.script';

export interface AppPaginationProps {
  showOption: boolean,
  pagination: {current: number, total: number, pages: number[], limit: number},
  loadPagination: Function
};

const AppPagination: React.FunctionComponent<AppPaginationProps> = ({showOption, pagination, loadPagination}) => {
  const handleChangePaginationTotal = (event: React.ChangeEvent <HTMLFormElement | HTMLSelectElement>) => {
    pagination.limit = Number(event.target.value)
    loadPagination(1, Number(event.target.value))
  }

  const executePaginationSelect = (item: number) => {
    let elements: string[] = []
  
    if (item === 1) {
      pageLimitDisabled('pagination-button-previous')
    } else {
      pageLimitEnabled('pagination-button-previous')
    }

    if (item === pagination.pages.length) {
      pageLimitDisabled('pagination-button-next')
    }else {
      pageLimitEnabled('pagination-button-next')
    }

    for (let item of pagination.pages) {
      elements.push(`pagination-button${suffixLegend(item)}`)
    }

    pageCurrent(item, elements)

    if (pagination.current !== item) {
      loadPagination(item)
    }
  }

  const executePaginationPrevious = () => {
    let current: number = pagination.current - 1
    let elements: string[] = []

    if (current === 1) {
      pageLimitDisabled('pagination-button-previous')
    }

    if (current < pagination.pages.length) {
      pageLimitEnabled('pagination-button-next')
    }

    for (let item of pagination.pages) {
      elements.push(`pagination-button${suffixLegend(item)}`)
    }

    pageCurrent(current, elements)
    loadPagination(current)
  }

  const executePaginationNext = () => {
    let current: number = pagination.current + 1
    let elements: string[] = []

    if (current > 1) {
      pageLimitEnabled('pagination-button-previous')
    }

    if (current === pagination.pages.length) {
      pageLimitDisabled('pagination-button-next')
    }

    for (let item of pagination.pages) {
      elements.push(`pagination-button${suffixLegend(item)}`)
    }

    pageCurrent(current, elements)
    loadPagination(current)
  }

  return (
    <>
      { pagination.total > 0 &&
        <div className="row">
          <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
            { showOption &&
              <div className="dataTables_length">
                <Form.Select bsPrefix="form-select form-select-sm" name="country" value={pagination.limit} onChange={handleChangePaginationTotal}>
                  <option value="" className={`${pagination.total !== 0 && "d-none"}`}>0</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </Form.Select>
              </div>
            }
          </div>
          { pagination.pages.length > 1 &&
            <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
              <div className="dataTables_paginate paging_simple_numbers">
                <ul className="pagination">
                  <li id="pagination-button-previous" className="paginate_button page-item previous disabled">
                    <button className="page-link" type="button" onClick={executePaginationPrevious}>
                      <i className="previous"></i>
                    </button>
                  </li>
                  { pagination.pages.map (( (item, index) => { return (
                    <li key={index} id={`pagination-button${suffixLegend(item)}`} className={`paginate_button page-item ${item === pagination.current && 'active' }`}>
                      <button className="page-link" type="button" onClick={() => executePaginationSelect(item)}>{item}</button>
                    </li>
                  )}))}
                  <li id="pagination-button-next" className="paginate_button page-item next">
                    <button className="page-link" type="button" onClick={executePaginationNext}>
                      <i className="next"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          }
        </div>
      }
    </>
  )
}

export default AppPagination;
